// Raw Material Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get fullRawMaterialsList from backend then set fullRawMaterialsList in vuex store ***** //
export const fetchFullRawMaterialsList = async ({ commit }) => {
  try {
    const result = await Axios.get('raw_materials_list')
    let list = result.data.data
    let fullList = []
    list.forEach(g => {
      fullList.push({
        value: g.product_id,
        text: g.product_name
      })
    })
    commit('setFullRawMaterialsList', fullList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get RawMaterialsList from backend then update RawMaterialsList in vuex store ***** //
export const updateRawMaterialsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('raw_materials_index', { params: params })
    commit('updateRawMaterialsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Raw Material from backend ***** //
export const fetchRawMaterialInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`raw_materials_show/${payload}`)
    commit('fetchRawMaterialInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Raw Material  ***** //
export const addRawMaterial = async (ignored, payload = null) => {
  try {
    await Axios.post('raw_materials_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Raw Material info ***** //
export const updateRawMaterialInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`raw_materials_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Raw Material  ***** //
export const deleteRawMaterial = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`raw_materials_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
